import styled from 'styled-components';
import { Box } from '@rsos/components/capstone/base';
import { DARK_THEME } from '@rsos/theme/constants';

export const Container = styled(Box).attrs({
  justify: 'center',
  pt: '16px',
  px: '16px',
})``;

export const NoData = styled(Box).attrs({
  bg: 'lightWarningText',
})`
  border-radius: 5px;
  color: ${({ theme }) => {
    // different colors based on design requirements
    if (theme.colors.name === DARK_THEME) {
      return theme.colors.primaryText;
    }
    return theme.colors.background;
  }};
`;
